export default __webpack_public_path__ + "static/media/logox0.5.38b79193.svg";